/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const BattleCalc = require('../../BattleCalc');
const Q_stunned = require('./Q_stunned');

const Q_can_i_just_kill_it = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.meleeAttack = BattleCalc.getEquippedAbility(actor, 'melee_attack');
  node.voidSpike = BattleCalc.getEquippedAbility(actor, 'void_spike');
  node.arrowShot = BattleCalc.getEquippedAbility(actor, 'arrow_shot');
  node.burningHands = BattleCalc.getEquippedAbility(actor, 'burning_hands');

  node.branches[node.NO] = new Q_stunned(actor, battleState);

  node.query = function (target) {
    if (!target) {
      return null;
    }

    if (this.yesNoEvalFunction(target)) {
      return null;
    } else {
      return this.branches[this.NO].query(target);
    }
  };

  node.getTopSingleTargetDamage = function () {
    var topDamage = this.meleeAttack.damage;

    if (this.burningHands && this.burningHands.damage > topDamage) {
      topDamage = this.burningHands.damage;
    }

    if (this.arrowShot && this.arrowShot.damage > topDamage) {
      topDamage = this.arrowShot.damage;
    }

    if (this.voidSpike && this.voidSpike.damage > topDamage) {
      topDamage = this.voidSpike.damage;
    }

    return topDamage;
  };

  node.yesNoEvalFunction = function (target) {
    return target.hp < this.getTopSingleTargetDamage();
  };

  return node;
};
module.exports = Q_can_i_just_kill_it;
